import Sign from '../components/SignatureUser/Sign'

let routes = {
    path: '/signDocumentByHash/',
    component: resolve => require(['../components/layout/Basic/App'], resolve),
    children: [
        {
            path: '/signDocumentByHash/:hash',
            name: 'Assinar',
            component: Sign
        },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/signatureUser.js